import React from 'react'
import { useSelector } from 'react-redux';
import { BannerJackpot } from '../../casino/ui/CarouselComponent';
import { Panel } from '../../contenful/types';
import { AppState } from '../../RootReducer';
import { BannerJackpotAmount } from '../../selectors/casino-selectors';
import { getJackpotForPanel } from '../../selectors/content-selectors';


const PanelSectionJackpotBanner = ({ panel }: { panel: Panel }): JSX.Element => {
    const jackpot = useSelector((app : AppState) => getJackpotForPanel(app, {id: panel.jackpotId as string, currency: panel.jackpotCurrency as string}));
    return <BannerJackpot banner={panel as Panel} jackpots={jackpot as BannerJackpotAmount[]}/>
}

export default PanelSectionJackpotBanner


